import {COLORS} from 'frontend/utils/color_palettes';

import {DefaultMapMarker, IconSize} from './default';

const SUBSTATION_COLOR = COLORS.NewPrimary.get(40);

/**
 * Marker represents substation on a map.
 */
export class SubstationMapMarker extends DefaultMapMarker {
  protected override getDefaultIcon(size: IconSize, opacity = 1): string {
    return substationSVG(size, opacity, SUBSTATION_COLOR);
  }

  protected override getRaisedIcon(size: IconSize, opacity = 1): string | null {
    return substationRaisedSVG(size, opacity, SUBSTATION_COLOR);
  }
}

function substationSVG(size: number, opacity: number, color: string): string {
  return `
<svg width="${size}" height="${size}" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <circle cx="12" cy="12" r="11" fill="${color}" stroke="white" stroke-width="2" opacity="${opacity}"/>
  <circle cx="12" cy="12" r="7" fill="white"/>
</svg>`;
}

function substationRaisedSVG(size: number, opacity: number, color: string): string {
  return `
<svg width="${size}" height="${size}" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
  <circle cx="16" cy="16" r="16" fill="white"/>
  <rect x="4" y="4" width="24" height="24" rx="12" fill="${color}" opacity="${opacity}"/>
  <circle cx="16" cy="16" r="8" fill="white"/>
</svg>`;
}
